<div class="d-flex justify-content-between">
  <!--Add Single Step-->
  <button
    type="button"
    class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
    (click)="viewFirearmDetailsClick()"
    >
    <i class="fa-solid fa-eye"></i>
  </button>

  @if (!params.data.form_4473_transfer_number && params.data.state === 'D') {
    <button
      type="button"
      class="btn btn-outline-primary btn-sm ag_grid_row_btn form-control py-0"
      (click)="printPackingSlipClick()"
      >
      <i class="fa-solid fa-print"></i>
    </button>
  }

  @if (params.data.has_pending_3310) {
    <button
      type="button"
      class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
      title="Send required Form 3310.4 for multiple handgun sale"
      (click)="send3310EmailClick()"
      >
      <i class="fa-solid fa-envelope"></i>
    </button>
  }
</div>
